import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeUIProvider, Box, InitializeColorMode } from 'theme-ui'
import IsSsrMobileProvider from '@/components/Commons/IsSsrMobileContext'
import { GlobalComponent } from '@/components/scripts/fonts'
import { CAMPAIGNS, FALLBACK_CAMPAIGN } from '@/constants/campaigns'

type LayoutProps = {
  theme: Theme
  isSsrMobile: boolean
  children: React.ReactNode
  path?: string
  campaign?: string
}

const queryClient = new QueryClient()

const defaultStyles: StyleObject = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}

const stwStyles: StyleObject = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    ':before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      background: 'url(/static/images/spintowin/backdrop.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      zIndex: -1,
    },

    ':after': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      background:
        'linear-gradient(180deg, #f37021 3%,rgba(34,34,34,0.75) 27%, rgba(34,34,34,1) 90%)',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      opacity: 1,
      zIndex: -1,
    },
  },
}

const bydsStyles: StyleObject = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    ':before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      background: 'url(/static/images/byds/backdrop.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
    },

    ':after': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      background:
        'linear-gradient(180deg, #f37021 3%,rgba(34,34,34,0.75) 27%, rgba(34,34,34,1) 90%)',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      opacity: 1,
      zIndex: -1,
    },
  },
}

const MainLayout = ({
  isSsrMobile,
  children,
  theme,
  campaign,
}: LayoutProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeUIProvider
        theme={(theme ?? FALLBACK_CAMPAIGN.theme) as unknown as Theme}
      >
        <GlobalComponent />
        <InitializeColorMode />
        <IsSsrMobileProvider value={isSsrMobile}>
          <Box as="main" sx={{ background: '#0C140C' }}>
            <Box
              sx={
                {
                  [CAMPAIGNS.BYDB.name]: bydsStyles.content,
                  [CAMPAIGNS.SPINTOWIN.name]: stwStyles.content,
                }[campaign ?? ''] ?? defaultStyles.content
              }
            >
              {children}
            </Box>
            <div data-iframe-height="1"></div>
          </Box>
        </IsSsrMobileProvider>
      </ThemeUIProvider>
    </QueryClientProvider>
  )
}

export default MainLayout
